module.exports = __webpack_public_path__ + "img/fig08.5f475306.jpg";